<template id="modal-template">
  <div class="modal-mask" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container" :class="containerClass" v-if="modalStore.name !== 'modalVideo'">
        <a
            class="modal-close"
            @click="close" :class="{ 'modal-close--favourite': modalStore.name === 'successFavouriteModal' }"
        >
          <i class="icon icon--cross icon--cross-size-20"></i>
        </a>
        <div
          class="modal-header"
          :class="{ 'd-none': (modalStore.name === 'successFavouriteModal' || modalStore.name === 'successFavouriteInitialModal') }"
        >
          <slot name="header"></slot>
        </div>

        <div
          class="modal-body"
          :class="[bodyClass, { 'modal-body--favourite': modalStore.name === 'successFavouriteModal', 'modal-body--initial': modalStore.name === 'successFavouriteInitialModal' }]"
        >
          <slot name="body"></slot>
        </div>
        <div class="modal-footer" v-if="modalStore.showFooter">
          <slot name="footer"></slot>
          <input type="hidden" id="id" name="id" :value="modalStore.id">
        </div>
        <div v-if="showBottomFooter">
          <slot name="footerbottom"></slot>
        </div>
      </div>

      <div class="modal-video" v-if="modalStore.name === 'modalVideo'">
        <a
          class="modal-close modal-close--video"
          @click="close"
          :class="{ 'modal-close--favourite': modalStore.name === 'successFavouriteModal' }"
        ><i class="icon icon--cross"></i><span class="sr-only">Close</span></a>
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, nextTick } from 'vue'
import useGlobalStore from '../../store/globalStore'

const props = defineProps({
  containerClass: {
    type: String,
    default: '',
  },
  bodyClass: {
    type: String,
    default: '',
  },
  showBottomFooter: {
    type: Boolean,
    default: false,
  }
})

const globalStore = useGlobalStore()
let modalStore = globalStore.modal

const close = () => {
  if (modalStore.name === 'careHomeSuggestedFormSuccess') {
    window.location = '/rest-homes/recommended-reading-watching'
  }

  globalStore.setModal({
    name: '',
    id: '',
    showFooter: false,
    title: '',
    descriptionPlaceholder: '',
    customField: '',
  })

  document.querySelector('body').classList.remove('modal-open', 'stop-scrolling')
  let currentUrl = window.location.href
  currentUrl = currentUrl.replace('/info-pack', '') // remove /info-pack once it close
  currentUrl = currentUrl.replace('/enquiry', '') // remove /enquiry once it close

  if (currentUrl.includes('/property-info')) {
    let url = `${window.location.protocol}//${window.location.host}/`
    const pathArray = window.location.pathname.split('/')
    currentUrl = `${url}${pathArray[1]}/${pathArray[2]}`
  }

  const urlParams = new URLSearchParams(window.location.search)
  const model = urlParams.get('modal')

  if (model) {
    currentUrl = currentUrl.replace(`?modal=${model}`, '')//remove  from url
  }

  history.pushState(null, null, currentUrl)

  if (localStorage.getItem('preSiteTitle')) {
    document.title = localStorage.getItem('preSiteTitle')
    localStorage.removeItem('preSiteTitle')
  }

  if (modalStore.refreshAfterClose) {
    location.reload()
  }
}

const toggleModalEvent = (e) => {
  const params = e.__livewire.params;
  globalStore.setModal({
    showFooter: params.showFooter,
    name: params.modalName,
  });
}

onMounted(async () => {
  if (modalStore.id !== '') {
    document.querySelector('body').classList.add('modal-open', 'stop-scrolling')
  }

  await nextTick()

  window.addEventListener('toggleModalEvent', toggleModalEvent);
  let components = Livewire.all();
  components.forEach((component) => {
    //console.log(component, component.$wire.captchaToken);
    grecaptcha.ready(function () {
      grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {action: 'submit'})
        .then(function (token) {
          if (modalStore.id !== '') {
            component.$wire.captchaToken = token;
          }
        });
    })

    if (component.id === 'rcDownload') {
      component.$wire.fileDownloadLink = modalStore.customField;
    }
  });
});
</script>
